import { ProjectTemplateBase } from './base/project-template-base';

export class ProjectTemplate extends ProjectTemplateBase { }